<script>
export default {
  name: 'OfferShow',
  props: {
    offer: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
}
</script>

<template>
  <div :class="$style.logo">
    <img
      v-if="offer.redemptionImage"
      :src="offer.redemptionImage"
      :alt="offer.name"
    >
  </div>
</template>

<style lang="scss" module>
  .logo {
    width: 100%;

    img {
      width: 100%;
      max-width: 360px;
      max-height: 360px;
      object-fit: cover;
    }
  }
</style>
